import axios from 'axios';

const API_URL = 'https://backend-sensores-736540514629.us-central1.run.app/api';

export const register = (user) => axios.post(`${API_URL}/auth/register`, user);
export const login = (user) => axios.post(`${API_URL}/auth/login`, user);
export const getSensores = (token) =>
  axios.get(`${API_URL}/sensor/list`, {
    headers: { Authorization: `Bearer ${token}` },
  });
